import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import {
    completeFosq10QuestionOptions,
    partialFosq10QuestionOptions,
} from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step1(props: IQuestionnaireFormProps) {
    return (
        <>
            <PageIntro
                subtitle={
                    'Met "slaperig" of "moe" bedoelen we het gevoel dat je je ogen niet open kunt houden, dat je wilt wegdoezelen of wilt gaan slapen. \
                We bedoelen niet het gevoel van vermoeidheid dat je hebt na het sporten.'
                }
                title="FOSQ-10: vragen deel 1/2"
            />

            <CustomContainer>
                <Stack>
                    <Step>1/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('difficultyConcentratingOnWork')}
                        label="Heb je regelmatig moeite met het concentreren op werkzaamheden omdat je slaperig of moe bent?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyConcentratingOnWork"
                            questionnaireOptions={partialFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>2/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('difficultyRememberingThings')}
                        label="Valt het je doorgaans moeilijk je dingen te herinneren omdat je slaperig of moe bent?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyRememberingThings"
                            questionnaireOptions={partialFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>3/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('difficultyDrivingAVehicleShortDistances')}
                        label="Heb je moeite met het besturen van een gemotoriseerd voertuig over korte afstanden (minder dan 160 km) omdat je slaperig of moe wordt?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyDrivingAVehicleShortDistances"
                            questionnaireOptions={completeFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>4/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('difficultyDrivingAVehicleLongDistances')}
                        label="Heb je moeite met het besturen van een gemotoriseerd voertuig over lange afstanden (meer dan 160 km) omdat je slaperig of moe wordt?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyDrivingAVehicleLongDistances"
                            questionnaireOptions={completeFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
